package amazon.lastmile.inject

import app.nestbridge.feature.profile.presentation.ProfilePresenterFactory
import com.slack.circuit.runtime.presenter.Presenter
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = ProfilePresenterFactory::class)
public interface AppNestbridgeFeatureProfilePresentationProfilePresenterFactory {
  @Provides
  @IntoSet
  public fun provideProfilePresenterFactoryFactoryMultibinding(profilePresenterFactory: ProfilePresenterFactory): Presenter.Factory = profilePresenterFactory
}
